module.exports = __webpack_public_path__ + "img/tic_icon.85363ba7.svg";